import EzUtils from "@/utils/EzUtils";

/***
 * callback : {result: "result(success/failed)", data: "data"}
 */

const SERVER_ERROR = "Server Error.";
const BAD_CREDENTIAL = "Bad credentials";
const CREDENTIALS_REQUIRED_ERROR = "Credentials are required to access this resource.";
const INTERNAL_500_ERROR = "500 Internal Server Error";
const FAILED_TO_UPDATE_LOAN_ERROR = "Failed to update loan information. Please contact support";
const NETWORK_ERROR = "Network Error";
const CHECK_NETWORK_CONNECTION = "Check your network connection";
const INVALID_REFRESH_TOKEN = "invalid refresh token";

export default {

  getNetworkIssueDetails(errorObject) {
    if (!errorObject) {
      return this.getErrorObject("", "");
    }

    const errorCode = errorObject.response ? errorObject.response.status : "";
    const errorMessage =
        errorObject.response ? errorObject.response.message : "";

    if (EzUtils.areEqualString(NETWORK_ERROR, errorMessage, true)) {
      return this.getErrorObject(NETWORK_ERROR, CHECK_NETWORK_CONNECTION);
    }

    if (errorObject.response) {
      const errorBody = errorObject.response.data;
      let title = "";
      let description = "";

      if (errorBody) {
        const userMessageGlobalisationCode =
            errorBody["userMessageGlobalisationCode"] || errorBody["data"];

        const defaultUserMessage =
            errorBody["defaultUserMessage"] || errorBody["message"];

        const errors = errorBody["errors"];
        const error = errorBody["error"];
        const errorDescription = errorBody["error_description"];

        if (userMessageGlobalisationCode
            && LOGOUT_ERROR_MAP[userMessageGlobalisationCode]
        ) {
          return this.getErrorObject(
              "",
              "",
              true,
              LOGOUT_ERROR_MAP[userMessageGlobalisationCode]
          );
        }

        if (EzUtils.isNotEmpty(errors)) {
          for (let i = 0, n = errors.length; i < n; i++) {
            const errorDetails = errors[i];
            if (errorDetails
                && EzUtils.isNotEmpty(errorDetails.userMessageGlobalisationCode)
                && LOGOUT_ERROR_MAP[errorDetails.userMessageGlobalisationCode]
            ) {
              return this.getErrorObject(
                  "",
                  "",
                  true,
                  LOGOUT_ERROR_MAP[errorDetails.userMessageGlobalisationCode]
              );
            }
          }
        }

        const customErrorKey = this.getCustomErrorKey(errorDescription);

        if (customErrorKey && LOGOUT_ERROR_MAP[customErrorKey]) {
          return this.getErrorObject(
              "",
              "",
              true,
              LOGOUT_ERROR_MAP[customErrorKey]
          );
        }

        if (userMessageGlobalisationCode
            && GLOBAL_ERROR_MAP[userMessageGlobalisationCode]
        ) {
          title = GLOBAL_ERROR_MAP[userMessageGlobalisationCode];
          description = defaultUserMessage;
        } else if (defaultUserMessage) {
          title = defaultUserMessage;
        }

        if (!title && !description) {
          title = this.getCustomErrorTitle(errorObject);
          if (!title) {
            title = errorMessage;
            if (!title) {
              title = errorDescription;
            }
          }
        }

        if (title || description) {
          return this.getErrorObject(title, description);
        }
      }

      if (EzUtils.isNotEmpty(errorObject.response.statusText)) {
        title = errorObject.response.statusText;
        if (EzUtils.isValidId(errorObject.response.status)) {
          title = errorObject.response.status + " " + title;
        }
      }
      if (EzUtils.isValidString(errorObject.response.data)
          && !this.isStringHtml(errorObject.response.data)
      ) {
        description = errorObject.response.data;
      }
      if (description) {
        return this.getErrorObject(description, "");
      } else if (title) {
        return this.getErrorObject(title, "");
      }
    }

    if (errorObject.request) {
      let title = "";
      let description = "";
      if (errorObject.request.statusText) {
        title = errorObject.request.statusText;
        if (errorObject.request.status) {
          title = errorObject.request.status + " " + title;
        }
      }
      if (errorObject.request.data && !this.isStringHtml(errorObject.request.data)) {
        description = errorObject.request.data;
      }

      if (description) {
        return this.getErrorObject(description, "");
      } else if (title) {
        return this.getErrorObject(title, "");
      }
    }

    if (errorObject.message) {
      return this.getErrorObject(errorObject.message, "");
    }

    return this.getErrorObject("", "");
  },

  getErrorObject(title, description, logoutOnError, toastMessageOnLogout) {
    return {
      title: title,
      description: description,
      logoutOnError: logoutOnError,
      toastMessageOnLogout: toastMessageOnLogout
    };
  },

  isStringHtml(value) {
    const htmlPattern = "[hH]{1}[tT]{1}[mM]{1}[lL]{1}";
    return value && EzUtils.doesPatternMatch(htmlPattern, value);
  },

  getCustomErrorTitle(errorObject) {
    const customErrorKey = this.getCustomErrorKey(errorObject);
    if (customErrorKey) {
      return GLOBAL_ERROR_MAP[customErrorKey];
    }
    return null;
  },

  getCustomErrorKey(errorObjectOrString) {
    let errorDescription = typeof errorObjectOrString == "string" ? errorObjectOrString : "";
    let errorCode = "";
    let error = "";

    if (typeof errorObjectOrString == "object" &&
        errorObjectOrString && errorObjectOrString.response) {
      const errorResponse = errorObjectOrString.response;

      errorCode = errorResponse.status ? errorResponse.status : "";

      if (errorResponse.data) {
        error = errorResponse.data.error;
        errorDescription = errorResponse.data.error_description;
      }
    }

    if (errorDescription
        && errorDescription.toLowerCase().includes(INVALID_REFRESH_TOKEN)
    ) {
      return CUSTOM_ERROR_MAP_KEYS.INVALID_REFRESH_TOKEN;
    }

    return EzUtils.join(".", errorCode, error);
  }
};

const GLOBAL_ERROR_MAP = {
  "error.msg.not.authenticated": "User Authentication Failed - Invalid username/password",
  "error.msg.dataintegrity": "There is an issue with your loan application request - Please contact customer support",
  "error.msg.badrequest": "The request was invalid. Please contact customer support if the issue persists",
  "error.msg.platform.server.side.error": "There is an error in processing the request. Contact Support if the problem persists",
  "error.msg.platform.service.unavailable": "System is undergoing maintenance. Please try after some time.",
  "creditengine.otp.not.verified": "OTP is not verified",
  "400.invalid_grant": "User Authentication Failed - Invalid username/password",
  "401.unauthorized": "User Authentication Failed - Looks like you are logged out, please login again",
  "error.msg.password.outdated": "Password expired. Please login again to continue.",
  "invalid.refresh.token": "Session expired. Please login again to continue."
};

const LOGOUT_ERROR_MAP = {
  "error.msg.password.outdated": "Password expired. Please login again to continue.",
  "invalid.refresh.token": "Session expired. Please login again to continue.",
};

const CUSTOM_ERROR_MAP_KEYS = {
  INVALID_REFRESH_TOKEN: "invalid.refresh.token"
}

